module.exports = __webpack_public_path__ + "img/djibouti.233bb83a.svg";